module.exports = __webpack_public_path__ + "img/轮播5.e70d6cac.png";